/**
 * @generated SignedSource<<5625f935251219da2455c78d4a975e37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Events_HideEventMutation$variables = {
  guid: string;
};
export type Events_HideEventMutation$data = {
  readonly hideEvent: {
    readonly ok: boolean | null;
  } | null;
};
export type Events_HideEventMutation = {
  response: Events_HideEventMutation$data;
  variables: Events_HideEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "guid"
      }
    ],
    "concreteType": "HideEventMutation",
    "kind": "LinkedField",
    "name": "hideEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Events_HideEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Events_HideEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fc8e96bb9777249b527d1e29beda656f",
    "id": null,
    "metadata": {},
    "name": "Events_HideEventMutation",
    "operationKind": "mutation",
    "text": "mutation Events_HideEventMutation(\n  $guid: String!\n) {\n  hideEvent(guid: $guid) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "77511a2a7af60bcfc8fb549d3e3d07fa";

export default node;
